import { useApiQuery } from '@/api/main/query'
import { PaginatedCollection } from '@/api/types'
import { fetchBankFailure, fetchBankStart, fetchBankSuccess } from '@/entities/banks'
import { Roles } from '@/entities/roles'
import { USER_ROLE_KEY } from '@/features/auth'
import { useToast } from '@/shared/hooks'
import { getStorageItem } from '@/shared/lib/storage/localStorage'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { BankModel } from '../model/types'

export const useBanksData = () => {
  const dispatch = useDispatch()
  const { addToast } = useToast()
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)

  const shouldFetch = userRole === Roles.Trader
  const { data: banksData, error: banksError } = useApiQuery<PaginatedCollection<BankModel[]>>(
    ['banks'],
    '/v1/banks/all',
    undefined,
    { enabled: shouldFetch }
  )

  // Эффект для старта загрузки
  useEffect(() => {
    if (!shouldFetch) return
    dispatch(fetchBankStart())
  }, [dispatch, shouldFetch])

  // Эффект для обработки ошибок
  useEffect(() => {
    if (!shouldFetch || !banksError) return
    const key = 'banks-error-handled'
    if (sessionStorage.getItem(key) === banksError.message) return
    sessionStorage.setItem(key, banksError.message)
    dispatch(fetchBankFailure(banksError.message))
    addToast('Ошибка!', banksError.message, 'error')
  }, [banksError, dispatch, addToast, shouldFetch])

  // Эффект для успешной загрузки
  useEffect(() => {
    if (!shouldFetch || !banksData) return

    sessionStorage.removeItem('banks-error-handled')
    dispatch(fetchBankSuccess(banksData.items ?? []))
  }, [banksData, dispatch, shouldFetch])

  return {
    data: banksData?.items ?? [],
    error: banksError,
    isLoading: shouldFetch && !banksData && !banksError,
  }
}
